import Vue from 'vue';

export default {
  // 获取托管订单列表数据
  getTrusteeshipList(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/application/list', {params});
  },
  // 托管订单验收
  inspectTrusteeship(params) {
    return Vue.axios.put('/rx/user/api/v1.0/service/application/inspect', params);
  },
  getOrderDetail(id) {
    return Vue.axios.get('/rx/user/api/v1.0/service/application/detail?id='+id);
  },
  finshedOrder(params) {
    return Vue.axios.put('/rx/user/api/v1.0/service/application/accomplish', params);
  },
  commentOrder(params) {
    return Vue.axios.put('/rx/user/api/v1.0/service/application/comment', params);
  }
};
